import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { AiOutlineInfo, AiOutlineInfoCircle } from 'react-icons/ai';
import './tooltips.css';
import {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from "axios";

function TooltipsPercentage() {
    const location = useLocation();
    const { id } = useParams();
    const [basicInfo, setBasicInfo] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const config = {headers: {authorization: `Bearer ${localStorage.getItem("accessToken")}`}};
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/get-employee-data/${id}`, config)
            .then(response => {
                setBasicInfo(response.data?.data);
            })
            .catch(error => {
                setError(error);
            });
    }, [location]);

  return (
    <>
        {/* <OverlayTrigger
          key='top'
          placement='top'
          overlay={
            <Tooltip id={`tooltip-top`} style={{textAlign: 'left !important'}}>
                <ul className='mt-3'>
                    <li  style={{textAlign: 'left !important'}}>ব্যক্তিগত তথ্য ({basicInfo?.employee_status == 1 ? '২০%' : '০%'})</li>
                    <li>কর্মকর্তা/কর্মচারীর ঠিকানা ({basicInfo?.address_status == 1 ? '২০%' : '০%'})</li>
                    <li>প্রাতিষ্ঠানিক শিক্ষার তথ্য ({basicInfo?.educational_info_status == 1 ? '২০%' : '০%'})</li>
                    <li>বর্তমান চাকুরির তথ্য ({basicInfo?.current_job_info_status == 1 ? '২০%' : '০%'})</li>
                    <li>যোগদানের তথ্য ({basicInfo?.joining_info_status == 1 ? '২০%' : '০%'})</li>
                </ul>
            </Tooltip>
          }
        >
          <Button variant='' style={{backgroundColor: 'rgb(104, 48, 145)', color: 'white'}} className='btn-sm text-center'>
            <AiOutlineInfoCircle /><small className='mt-1'> প্রোফাইল {basicInfo?.percentage}%</small>
          </Button>
        </OverlayTrigger> */}
        <small style={{fontWeight: '500', fontSize: '14px', top: 11, position: 'absolute'}}>
        (প্রোফাইল সম্পূর্ণ হয়েছে {basicInfo?.percentage ? basicInfo?.percentage : 0}%
          {basicInfo?.percentage != 100 && ', অসম্পূর্ণ আছে - '}
          {basicInfo?.employee_status != 1 && 'ব্যক্তিগত তথ্য, '}
          {basicInfo?.address_status != 1 && 'কর্মকর্তা/কর্মচারীর ঠিকানা, '}
          {basicInfo?.educational_info_status != 1 && 'প্রাতিষ্ঠানিক শিক্ষার তথ্য, '}
          {basicInfo?.current_job_info_status != 1 && 'বর্তমান চাকুরির তথ্য, '}
          {basicInfo?.joining_info_status != 1 && 'যোগদানের তথ্য'}
        )
        </small>
    </>
  );
}

export default TooltipsPercentage;